import React from "react";
import { Button } from "reactstrap";
import Ink from "react-ink";


import "./style.css";

export default function GradientButton({
  label = "Login",
  containerClasses = "",
  BTNClass = "",
  onClick,
  type = "button"
}) {
  return (
    <div className={`gradient-button-container ${containerClasses}`}>
      <Button type={type} onClick={onClick} className={`${BTNClass} gradient-button`} block>
        {label}
        <Ink />
      </Button>
    </div>
  );
}
